var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 11.4,
    height: 3.4,
    rx: 0.7,
    fill: "white",
    stroke: "current",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 2.3,
    width: 7.4,
    height: 9.4,
    rx: 0.7,
    fill: "white",
    stroke: "current",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82322 10.1768C5.92085 10.2744 6.07915 10.2744 6.17678 10.1768L7.76777 8.58579C7.8654 8.48816 7.8654 8.32986 7.76777 8.23223C7.67014 8.1346 7.51184 8.1346 7.41421 8.23223L6 9.64645L4.58579 8.23223C4.48816 8.1346 4.32986 8.1346 4.23223 8.23223C4.1346 8.32986 4.1346 8.48816 4.23223 8.58579L5.82322 10.1768ZM5.75 5L5.75 10L6.25 10L6.25 5L5.75 5Z",
    fill: "#2653F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalIcon);
export default __webpack_public_path__ + "static/media/withdrawalIcon.d17dd27eba28870dec68430327583100.svg";
export { ForwardRef as ReactComponent };